export {
  convertPlanToProduct,
  convertLogoToProduct,
  noScriptTagsGTM,
  scriptTagsGTM,
} from './gtm-helpers'

export { getCIOSnippet } from './cio-helpers'

export { setLanguage, getLanguage, getCurrency, setCurrency } from './cookies'

export { getHotjarScriptIfEnabled } from './hotjar-helpers'

export const MAX_LOGOS_PER_REQUEST = 30
export const MIN_LOGOS_PER_REQUEST = 0
export const DATA_PALETTE_PATTERN = /(data-fill-palette-color|data-stroke-palette-color)=\\?"[a-zA-Z]+\\?"/g

export { isProd, isDev, isLocal } from '../lib/helpers'

/**
 * Returns the amount in dollars of the discount being applied.  Necessary because orders and carts
 * totals are calculated after a discount is applied, while items price amounts are calculated before.
 *
 * Therefore, you need to subtract the total from the value of all the items.
 * @param {number} total The total in cents
 * @param {{ id: string, package: Object, quantity: number }} items The Items of a Cart or Order
 */
export const calculateDollarDiscount = (total, items) => {
  return (items.reduce((a, x) => (a += x.price * x.quantity), 0) - total) / 100
}
